import React, {forwardRef} from 'react';
import useStyles from "isomorphic-style-loader/useStyles";
import PropTypes from "prop-types";
import WallpaperIcon from '@material-ui/icons/Wallpaper';
import Button from '@material-ui/core/Button';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelOutlinedIcon from '@material-ui/icons/CancelOutlined';

import BlessImageButtonStyles from './BlessImageButton.scss';
import PulseLoader from "react-spinners/PulseLoader";

const BlessImageButton = forwardRef(({ isBlessedImage, isLoading, className, ...buttonProps }, ref) => {
  useStyles(BlessImageButtonStyles);

  return (
    <Button ref={ref} className={`bless-image-button ${className}`} {...buttonProps}>
      {isLoading && <PulseLoader
        loading={isLoading}
        color="#fff"
        sizeUnit="px"
        size={10}
      />}
      {!isLoading && (<>
        <WallpaperIcon className="bless-image-button__icon" />

        {isBlessedImage ? (
          <CancelOutlinedIcon className="bless-image-button__action-icon bless-image-button__action-icon-cancel" />
        ) : (
          <CheckCircleIcon className="bless-image-button__action-icon bless-image-button__action-icon-check" />
        )}
      </>)}
    </Button>
  )
});

BlessImageButton.propTypes = {
  isBlessedImage: PropTypes.bool,
  isLoading: PropTypes.bool,
  ...Button.propTypes
}

export default React.memo(BlessImageButton);
